import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { OsrmModel } from '../models/osrm.model';

@Injectable({
  providedIn: 'root'
})
export class OsrmService {

  constructor(
    private httpClient: HttpClient
  ) { }
 // &geometries=geojson
  getRoute(origen: number[], destino: number[]): Observable<OsrmModel> {
    if (environment.use_proxy_url_for_osrm) {
      const param = encodeURIComponent(`${environment.base_url_osrm}${origen};${destino}?steps=true`);
      return this.httpClient.get<OsrmModel>(`${environment.baseApi}${environment.proxy_url_for_osrm}${param}`);
    } else {
      return this.httpClient.get<OsrmModel>(`${environment.base_url_osrm}${origen};${destino}?steps=true`);
    }
  }
}
